import { Image } from '@modusign/design-system';

function CheckIcon() {
  return (
    <Image src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0naHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmcnIHdpZHRoPScxNCcgaGVpZ2h0PScxNCcgdmlld0JveD0nMCAwIDE0IDE0Jz48cG9seWxpbmUgZmlsbD0nbm9uZScgc3Ryb2tlPScjQjVCNUI1JyBzdHJva2Utd2lkdGg9JzInIHBvaW50cz0nMTIgNCA2IDEwIDIgNicvPjwvc3ZnPg==" />
  );
}

export default CheckIcon;
